import React from "react";
import InfoTile from "./InfoTile";
import AppActionButton from "./AppActionButton";
import {InstalledAppDetailsResponse} from "../../../logic/APITypes";

type InstalledAppTileProps = {
  appDetails: InstalledAppDetailsResponse;
  groupId: string;
  isGroupAdmin: boolean;
  appId: string;
};

/** Tile specific to installed applications */
function InstalledAppTile({
  appDetails,
  groupId,
  isGroupAdmin,
  appId,
}: InstalledAppTileProps) {
  return (
    <>
      <InfoTile
        currentVersion={appDetails.current_app_version}
        latestVersion={appDetails.latest_app_version}
        homeUrl={appDetails.home_url}
      >
        <AppActionButton
          groupId={groupId}
          isGroupAdmin={isGroupAdmin}
          appId={appId}
          status="installed"
          requiresParameters={false}
        />
      </InfoTile>
    </>
  );
}

export default InstalledAppTile;
